<template>
  <section
    v-if="labels && labels?.length > 0"
    class="repo-label-list"
  >
    <repo-label-item
      v-for="label in labels"
      :key="label?.id"
      :label="label"
      :deletable="deletable"
      @delete="onLabelDelete"
    ></repo-label-item>
    <empty-listing
      v-if="!!labels && !labels?.length"
      :title="$tc('message.label', 3)"
    />
  </section>
</template>

<script>
import EmptyListing from '@shared/shared-components/empty-listing';
import RepoLabelItem from '@shared/shared-components/shared/RepoLabelItem';

export default {
  name: 'RepoLabelList',
  components: { EmptyListing, RepoLabelItem },
  props: {
    labels: {
      default: null
    },
    deletable: {
      default: false
    }
  },
  watch: {
    labels: {
      handler() {
        this.$nextTick(() => {
          // Для отрабатывания скрипта только после того, как лейбл был отрисован на странице
          calculateParentBackground(); // функция из scripts.js
        });
      },
      immediate: true // Для отрабатывания скрипта, при первичной отрисовке лейблов на странице (т.е. до мутаций пропсов)
    }
  },
  methods: {
    onLabelDelete(label) {
      this.$emit('delete', label);
    }
  }
};
</script>

<style lang="scss">
$this: '.repo-label-list';

#{$this} {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  color: var(--text-muted);
}
</style>
